import { FC } from "react";
import DefaultProfilePicture from "../../../../assets/img/default-image.svg";
import { DEFAULT_ITEMS_PER_PAGE } from "../../../../constants/app";
import { getTimeFromDate } from "../../../../services/TimesheetService";
import { PaginationLink } from "../../../../store/superadmin/types";
import { ICandidateTimesheetData, IPaginatedDataa } from "../../../../store/timesheet/types";
import { extractSuburbFromAddress } from "../../../../utils/stringUtils";
import PaginationControls from "../../../Pagination/PaginationControls";
import Break from "../../../UI/Icons/Break";
import CircleCancel from "../../../UI/Icons/CircleCancel";
import LogIn from "../../../UI/Icons/LogIn";
import LogOut from "../../../UI/Icons/LogOut";

interface ListItemsProps {
  historyTimesheetLists: IPaginatedDataa<ICandidateTimesheetData> | null;
  currentPage: number;
  totalPages: number;
  paginationLinks: PaginationLink[];
  onPageChange: (url: string | null) => void;
  setPerPageList: (value: number) => void;
  setCurrentPage: (value: number) => void;
}

const ListItems: FC<ListItemsProps> = ({
  historyTimesheetLists,
  currentPage,
  totalPages,
  paginationLinks,
  onPageChange,
  setPerPageList,
  setCurrentPage,
}) => {
  return (
    <>
      {historyTimesheetLists && historyTimesheetLists?.total > 0 ? (
        historyTimesheetLists.data.map(
          (
            historyTimesheetList: ICandidateTimesheetData,
            index: number
          ) => (
            <div key={index} className="border-bottom border-off-white p-15px d-flex gap-20 align-items-lg-center">
              <div className="w-50px h-50px  border-2 border-grey-dark radius-40px">
                <img
                  src={historyTimesheetList.centre.photo ?? DefaultProfilePicture}
                  alt="centre-photo"
                  width={50}
                  height={50}
                  className="img-responsive rounded-circle object-fit-cover"
                />
              </div>
              <div className="flex-grow-1 d-flex flex-column flex-lg-row gap-20 align-items-lg-center">
                <div className="flex-grow-1 d-flex flex-column gap-3 text-break">
                  <div className="fs-16 fw-700 text-black">
                    {historyTimesheetList.centre.business_name},{" "}
                    <span className="fw-400">{extractSuburbFromAddress(historyTimesheetList.centre.address || "")}</span>
                  </div>
                  <div className="fs-13 fw-400 text-black">
                    {historyTimesheetList?.vacancy?.matching_position?.name}
                  </div>
                </div>
                <div className="min-w-250px w-205px text-break fs-13 fw-400 text-black">
                  <span className="d-block d-lg-none fw-700">
                    Job Timeframe
                  </span>
                  {/* { formatReadableTimeSlot(
                      format(new Date(historyTimesheetList.timeframe.start_date ?? ""), "yyyy-MM-dd"), 
                      historyTimesheetList.timeframe.start_time || "", 
                      historyTimesheetList.timeframe.end_time || "")
                  } */} 
                  {
                    historyTimesheetList?.timesheet_date_time || "-"
                  }
                </div>
                <div className={`d-flex gap-30 min-w-380px mobile-w-100 ${historyTimesheetList?.did_not_work ? 'd-none' : ''}`}>
                  <div className="d-flex gap-10 align-items-center">
                    <div className="d-none d-lg-block">
                      <LogIn />
                    </div>
                    <div className="d-flex flex-column">
                      <div className="fs-13 fw-700 text-black">
                        <span className="d-none d-lg-block">Job Start</span>
                        <span className="d-block d-lg-none">Start</span>
                      </div>
                      <div className="fs-13 fw-400 text-black">{getTimeFromDate &&
                      getTimeFromDate(historyTimesheetList?.job_start_time ?? null)}</div>
                    </div>
                  </div>
                  <div className="d-none d-lg-flex gap-10 align-items-center">
                    <div className="d-none d-lg-block">
                      <Break />
                    </div>
                    <div className="d-flex flex-column">
                      <div className="fs-13 fw-700 text-black">
                        Break Timeframe
                      </div>
                      <div className="fs-13 fw-400 text-black">
                        {historyTimesheetList?.break_start_time === null &&
                          historyTimesheetList?.break_end_time === null
                          ? "-"
                          : getTimeFromDate(
                              historyTimesheetList?.break_start_time ?? null
                            ) +
                            " to " +
                            getTimeFromDate(historyTimesheetList?.break_end_time ?? null)}
                      </div>
                    </div>
                  </div>
                  <div className="d-flex gap-10 align-items-center">
                    <div className="d-none d-lg-block">
                      <LogOut color="#167E76" />
                    </div>
                    <div className="d-flex flex-column">
                      <div className="fs-13 fw-700 text-black">
                        <span className="d-none d-lg-block">Job End</span>
                        <span className="d-block d-lg-none">End</span>
                      </div>
                      <div className="fs-13 fw-400 text-black">{getTimeFromDate &&
                      getTimeFromDate(historyTimesheetList?.job_end_time ?? null)}</div>
                    </div>
                  </div>
                  {/* Mobile Screen Break Format */}
                  <div className="d-flex d-lg-none flex-column">
                    <div className="fs-13 fw-700 text-black">Break</div>
                    <div className="fs-13 fw-400 text-black">45min</div>
                  </div>
                </div>

                <div className={`d-flex align-items-center justify-content-center gap-10 min-w-380px mobile-w-100 fs-13 fw-700 d-flex gap-10 ${historyTimesheetList?.did_not_work ? '' : 'd-none'}`}>
                      <CircleCancel fill="#AAAAAA" />  I did not work on this day
                </div>

              </div>
            </div>
          )
        )
      ) : (
        <div className="d-flex gap-20 align-items-center justify-content-center text-center p-15px">
          <div className="fs-16 fw-400 text-grey-medium">No history found</div>
        </div>
      )}
      {historyTimesheetLists &&
        historyTimesheetLists?.total > DEFAULT_ITEMS_PER_PAGE && (
          <PaginationControls
            currentPage={currentPage}
            totalPages={totalPages}
            paginationLinks={paginationLinks}
            onPageChange={onPageChange}
            setPerPageList={setPerPageList}
            setCurrentPage={setCurrentPage}
          />
        )}
    </>
  );
};

export default ListItems;
